import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","border":"0","color":"black"} }, "1. Choose an Image or Upload an Image")
], -1)
const _hoisted_2 = ["id", "onClick"]
const _hoisted_3 = { class: "holly-data" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 0 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "Target Image")
], -1)
const _hoisted_5 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_6 = { style: {"margin":"30px 0","width":"80%"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 40px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "2. Choose a Model and an Algorithm")
], -1)
const _hoisted_8 = { class: "holly-detect" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0 0 20px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","border":"0","color":"black"} }, "3. Inference Result")
], -1)
const _hoisted_10 = { style: {"background-color":"#E7E7E7","width":"94%","padding":"20px","margin":"0 20px 0 0","border":"2px solid #a1a1a1","border-radius":"25px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { style: {"background-color":"#E7E7E7","font-size":"30px","color":"black","border":"0","font-family":"'Microsoft Yahei'"} }, "GroundTruth: ", -1)
const _hoisted_12 = { style: {"background-color":"#E7E7E7","font-size":"30px","color":"#C40000","border":"0","font-family":"'Microsoft Yahei'"} }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { style: {"background-color":"#E7E7E7","font-size":"30px","color":"black","border":"0","font-family":"'Microsoft Yahei'"} }, "Predicted: ", -1)
const _hoisted_15 = { style: {"background-color":"#E7E7E7","font-size":"30px","color":"#C40000","border":"0","font-family":"'Microsoft Yahei'"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { style: {"background-color":"#E7E7E7","font-size":"30px","color":"black","border":"0","font-family":"'Microsoft Yahei'"} }, "Probability: ", -1)
const _hoisted_18 = { style: {"background-color":"#E7E7E7","font-size":"30px","color":"#C40000","border":"0","font-family":"'Microsoft Yahei'"} }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"20px 0 20px 0","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"35px","color":"black","border":"0"} }, "4. Attribution map")
], -1)
const _hoisted_21 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_22 = { style: {"margin":"30px 0"} }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = ["src"]

import {Plus, Chicken} from "@element-plus/icons-vue";
// import axios from "axios";

import {UploadInstance, UploadProps} from "element-plus/es";
// import {useStore} from "vuex";
import {router} from "@/router";
import {ElMessage} from "element-plus";
import request from "@/api";
import {reactive, ref} from "vue";
import {useStore} from "vuex";
import axios from "axios";
import DataUpload from "./DataUpload.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'imagenet',
  emits: ['updateFileList'],
  setup(__props, { emit: emits }) {



// const store = useStore();
const uploadShow = ref(false);
const uploadFileList = ref([]);
const uploadRef = ref<UploadInstance>();
const dialogImageUrl = ref("");
const dialogVisible = ref(false);



const componentKey = ref(0);
const last_id = ref(666)
const chosenModel = ref('')
const chosenImg = ref('')
const istrue = ref(false)
const chosenAlgorithm = ref('')
const activate = ref(-1)
const chosen = ref([])
let resultLoading = ref(false)
let resultShow = ref(false)

const GroundTruth = ref('')
const Predicted = ref('')
const Probability = ref('')
const gpu = ref('')
const memory = ref('')
const error_img = ref([false, false])

const chosenEnhanceAlgorithm = ref('')
const chosenStitchingAlgorithm = ref('')
const store = useStore();
const listPage = ref(1), imageNumber = ref(8);
const fileList = ref([]), datasetInformation = ref({}), fileList2 = ref([]);
let selectList = Array(imageNumber.value).fill(0);
let deleteShow = ref(false);
const showList = ref([]), listPreview = ref([]), showListPool = ref([]), listPreview2 = ref([]);

async function refreshImages(option) { //推理之后才提交的, 刷新右边的结果
  // console.log(option);
  await getDatasetInfos(option);
  updateShowList();
}

async function getDatasetInfos(option) {
  let requestUrl = "/dataset/" + option, requestData = {};
  requestData["datasetId"] = 666; //其实用不上
  await request.post(requestUrl, requestData)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          fileList.value = (res.data.data);
        } else {
          console.log("err request");
        }
      })
      .catch((err) => {
        console.log(err);
      });
}

// const imageLoadStatus = ref([]);

const updateShowList = () => {
  showList.value = fileList.value
  console.log("showList.value", showList.value);
  // listPreview.value = (showList.value.map((e) => {
  //   return "http://" + e;
  // }));
  // console.log("listPreview.value", listPreview.value)
};


async function realRefreshImages(option){  //图像池的刷新
  await getImgPoolInfos(option);
  updatePoolList();
}

async function getImgPoolInfos(option){
  let requestUrl = "/dataset/" + option, requestData = {};
  requestData["datasetId"] = 10002;
  await request.post(requestUrl, requestData)
      .then((res) => {
        console.log("res.data: ", res.data);

        if (res.status === 200) {
          fileList2.value = (res.data.data);
          chosen.value[0] = res.data.data[0]
        } else {
          console.log("err request");
        }
      })
      .catch((err) => {
        console.log(err);
      });
}

const updatePoolList = () => {
  showListPool.value = fileList2.value
  console.log("showListPool.value", showListPool.value);
  listPreview2.value = (showListPool.value.map((e) => {
    return "http://" + e;
  }));
  console.log("listPreview2.value", listPreview2.value)
};

async function refreshCifar(){  //懒得改名字了~
  realRefreshImages("getPool");
  activate.value = -1;
  // let last_d = document.getElementById(last_id.value.toString()) //对应被注释掉的那种写法
  // last_d.style.border = "2px solid white";
  // last_id.value == 666
}

realRefreshImages("getPool");

const selectChange = (index) => {
  selectList[index] ^= 1;
  console.log(selectList);
};

function uploadDataset() {
  router.push('datasetPreview')
}

// changeColor(()=>{
//   this.$refs.abc.style.border = '2px solid red';
// })
function changeColor(event){  // vue正常思路：用组件的active，但是好像要用data()，以后学了再改吧
  console.log("event", event)
  console.log("event.currentTarget.id", event.currentTarget.id)
  // console.log("document.getElementById(event.currentTarget.id).style.border", document.getElementById(event.currentTarget.id).style.border)
  let d = document.getElementById(event.currentTarget.id)
  d.style.border = "4px solid red";
  if(last_id.value == 666){
    last_id.value = event.currentTarget.id
  }else{
    let last_d = document.getElementById(last_id.value.toString())
    last_d.style.border = "2px solid white";
    last_id.value = event.currentTarget.id
  }
}
// const changeColor = () =>
// {
//     console.log(this.refs)
//     // this.refs.abc.style.border = '2px solid red';
//   // obj.style.border = '2px solid red';
// }

function chooseImg($event) {
  console.log("$event", $event)
  console.log("$event.srcElement.currentSrc", $event.srcElement.currentSrc)
  let arr = $event.srcElement.currentSrc.split("/")
  chosenImg.value = arr[arr.length - 1]
  chosen.value[0] = $event.srcElement.currentSrc.substring(7);
  console.log("图片名称", chosenImg.value)
}

const forceRerender = () => {
  console.log(componentKey.value)
  componentKey.value += 1;

};

const handleError = () =>{
  this.loadError = true;
  this.errorMsg = '加载失败，可能是当前算力不足';
}

async function startRecognize() {
  console.log("start Recognize")

  if(!chosenModel.value){
    ElMessage.error('请选择要使用的模型')
    return
  }
  if(!chosenAlgorithm.value){
    ElMessage.error('请选择要使用的算法')
    return
  }
  if(!chosenImg.value){
    ElMessage.error('请选择要解释的图像')
    return
  }

  resultLoading.value = true
  await request.post('/algorithm/callAlgorithm',{
    algorithmName:chosenAlgorithm.value,
    datasetId: 666,
    datasetName: "ImageNet",
    modelName: chosenModel.value,
    userName: chosenImg.value,
    // userName: store.state.username,
  })
      .then((response)=>{
        console.log("response", response)
        fileList.value[0] = (response.data.data.result[4]);
        fileList.value[1] = (response.data.data.result[5]);
        GroundTruth.value = response.data.data.result[1];
        Predicted.value = response.data.data.result[2];
        Probability.value = response.data.data.result[3].slice(12,18) + "%";
      })
      .catch((error)=>{
        console.error(error)
      })

  showList.value = fileList.value

  console.log("showList.value", showList.value);


  await request.post('/algorithm/reportGpu',{
    algorithmName:chosenAlgorithm.value,
    datasetId: 666,
    datasetName: "ImageNet",
    modelName: chosenModel.value,
    userName: chosenImg.value,
    // userName: store.state.username,
  })
      .then((response)=>{
        gpu.value = response.data.data.result[0];
        memory.value = response.data.data.result[1];
      })
      .catch((error)=>{
        console.error(error)
      })
  resultShow.value = true
  resultLoading.value = false

  // const imageLoadStatus = image Array(showList.value.length).fill('loading');
  // console.log("imageLoadStatus", imageLoadStatus)
  // showList.value.forEach((item, index) => {
  //   const img = image Image();
  //   img.src = `http://${item}`;
  //   console.log("img.src", img.src)
  //   console.log("img.onload", img.onload)
  //   console.log("img.onerror", img.onerror)
  //   img.onload = () => {
  //     imageLoadStatus[index] = 'loaded';
  //     // listPreview.value.push(img.src);
  //   };
  //   img.onerror = () => {
  //     imageLoadStatus[index] = 'error';
  //   };
  // });
  // console.log("imageLoadStatus", imageLoadStatus)

  // listPreview.value = (showList.value.map((e) => {
  //   return "http://" + e;
  // }));
  // console.log("listPreview.value", listPreview.value)
}


function infoFailure(){
  const messageOptions = {
    message: 'The algorithm failed to execute successfully, ' +
        'possibly due to insufficient computing power, internal errors, or other reasons. ' +
        'The maximum available computing power on the server is ' + memory.value + ', located on GPU ' + gpu.value + '. Please try again later.',
    duration: 10000  // 设置延迟时间为5秒
  };
  ElMessage.error(messageOptions)
  return
}

function infoSuccess(){
  ElMessage.success('The algorithm executed successfully!')
  return
}






const handleRemove: UploadProps["onRemove"] = (uploadFile, uploadFiles) => {
  // console.log(uploadFileList);
  // const index=uploadFileList.value.findIndex((e)=>{return e===uploadFile})
  console.log(uploadFile, uploadFiles);
};
const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!;
  dialogVisible.value = true;
  // console.log("dialogImageUrl.value: ", dialogImageUrl.value)
};
const handleChange: UploadProps["onChange"] = (file, fileList) => {
  uploadFileList.value = fileList;
};
async function submitUpload(){
  let param = new FormData();
  console.log("uploadFileList: ", uploadFileList);
  uploadFileList.value.forEach(
      (val, index) => {
        param.append("pictures", val.raw);
        console.log("test", val.raw);
      }
  );
  console.log("datasetId: ", store.state.datasetId);
  param.append("datasetId", store.state.datasetId);
  let config = {
    baseURL: "/api",
    //baseURL: "http://localhost:7996",
    timeout: 30000,
    headers: {
      "Content-Type": "multipart/form-data" //设置headers
    }
  };
  console.log("param: ", param);
  await axios
      .post("/data/uploadPictures", param, config)
      .then(res => {
        console.log("res: ", res);
        if (res.status === 200) {
          console.log("yes");
          uploadRef.value.clearFiles();
          uploadFileList.value = [];
          chosen.value[0] = res.data.data.imgpath;
          console.log("chosen: ", chosen.value);
          let arr = chosen.value[0].split("/")
          chosenImg.value = arr[arr.length - 1]
          console.log("图片名称", chosenImg.value)
        }
      })
      .catch(err => {
        console.log(err);
      });
  console.log("uploadFileList: ", uploadFileList);
  emits('updateFileList','getDatasetInfo')
  uploadShow.value = false;
  // fileList= fileList.concat(file)
}


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_backtop = _resolveComponent("el-backtop")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, { style: {"background-color":"white","width":"50%","padding":"20px"} }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showListPool.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_col, {
                  span: 4,
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      id: index,
                      class: "block2",
                      onClick: ($event: any) => (activate.value = index),
                      style: _normalizeStyle({border: activate.value === index ? '2px solid red' : '2px solid white'})
                    }, [
                      (_openBlock(), _createBlock(_component_el_image, {
                        src: `http://${item}`,
                        "initial-index": index,
                        style: {"width":"100%","height":"100%"},
                        fit: 'fill',
                        key: componentKey.value,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (chooseImg($event)))
                      }, null, 8, ["src", "initial-index"]))
                    ], 12, _hoisted_2)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              size: "large",
              type: "primary",
              onClick: refreshCifar,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Refresh Image Pool")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (uploadShow.value=true)),
              size: "large",
              type: "warning",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Upload Your Image")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { style: {"background-color":"white"} }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createBlock(_component_el_image, {
                src: `http://${chosen.value}`,
                fit: 'fill',
                style: 'width: 100%;',
                key: componentKey.value,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (chooseImg($event)))
              }, null, 8, ["src"]))
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_select, {
              modelValue: chosenModel.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((chosenModel).value = $event)),
              placeholder: "Choose a Model",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "ResNet18",
                  value: "ResNet18"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_select, {
              modelValue: chosenAlgorithm.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((chosenAlgorithm).value = $event)),
              placeholder: "Choose an Algorithm",
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "Integrated Gradients (IG)",
                  value: "IG"
                }),
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "IG with noise tunnel",
                  value: "IG_with_noise_tunnel"
                }),
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "GradientShap",
                  value: "GradientShap"
                }),
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "Occlusion",
                  value: "Occlusion"
                }),
                _createVNode(_component_el_option, {
                  key: "6",
                  label: "Occlusion with a larger sliding window",
                  value: "Occlusion_using_larger_sliding_window"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              size: "large",
              type: "success",
              onClick: startRecognize,
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Inference")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            style: _normalizeStyle({visibility:_unref(resultShow)?'visible':'hidden'})
          }, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("label", _hoisted_12, _toDisplayString(GroundTruth.value), 1),
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("label", _hoisted_15, _toDisplayString(Predicted.value), 1),
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("label", _hoisted_18, _toDisplayString(Probability.value), 1),
              _hoisted_19
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_el_image, {
                    src: `http://${item}`,
                    fit: 'fill',
                    "preview-src-list": showList.value.map(x=>'http://'+x),
                    "initial-index": index,
                    onError: _cache[5] || (_cache[5] = ($event: any) => (infoFailure())),
                    onLoad: _cache[6] || (_cache[6] = ($event: any) => (infoSuccess()))
                  }, null, 8, ["src", "preview-src-list", "initial-index"])
                ]))
              }), 256))
            ])
          ], 4)
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: uploadShow.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((uploadShow).value = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_25, [
            _createVNode(_component_el_button, {
              type: "danger",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (uploadShow.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "success",
              onClick: submitUpload
            }, {
              default: _withCtx(() => [
                _createTextVNode("Upload")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            method: "post",
            action: "#",
            "list-type": "picture-card",
            "on-preview": handlePictureCardPreview,
            "on-remove": handleRemove,
            "on-change": handleChange,
            "auto-upload": false,
            limit: 1,
            "show-file-list": uploadFileList.value.length === 1,
            "file-list": uploadFileList.value
          }, {
            trigger: _withCtx(() => [
              (uploadFileList.value.length === 0)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createTextVNode(" Upload only one "),
                    _hoisted_24,
                    _createTextVNode(" image at a time ")
                  ]))
            ]),
            _: 1
          }, 8, ["show-file-list", "file-list"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dialogVisible).value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: dialogImageUrl.value,
            alt: "Preview Image"
          }, null, 8, _hoisted_26)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_backtop, {
        right: 100,
        bottom: 100
      })
    ]),
    _: 1
  })), [
    [_directive_loading, _unref(resultLoading)]
  ])
}
}

})